import { render } from "./index.vue?vue&type=template&id=784b16fa&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=784b16fa&scoped=true&lang=css"
import "./index.vue?vue&type=style&index=1&id=784b16fa&lang=css"

import exportComponent from "/workspace/cgsfront/cgs-office-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-784b16fa"]])

export default __exports__